import { render, staticRenderFns } from "./DatabaseDestinationRestore.vue?vue&type=template&id=68ff3de8"
import script from "./DatabaseDestinationRestore.vue?vue&type=script&lang=js"
export * from "./DatabaseDestinationRestore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports